import { Card, Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { IconClock } from "@tabler/icons-react";

const ComingSoon = () => {
  return (
    <Stack direction="column" justify="center" align="center" className="al-h-full al-p-6">
      <Card className="al-p-8 al-max-w-md al-w-full">
        <Stack direction="column" gap="lg" align="center">
          <div className="al-rounded-full al-bg-gradient-to-br al-from-blue-500 al-to-purple-600 al-p-6">
            <IconClock size={48} className="al-text-white" />
          </div>
          <Stack direction="column" gap="sm" align="center">
            <Typography variant="page-heading">
              Coming Soon
            </Typography>
            <Typography variant="body" size="regular" className="al-text-center al-text-muted-foreground">
              This feature is currently under development and will be available soon.
            </Typography>
          </Stack>
        </Stack>
      </Card>
    </Stack>
  );
};

export { ComingSoon };
